module.exports = __webpack_public_path__ + "img/total-price.97baeb83.svg";